import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import BaseSelect from 'components/baseSelect' ;
import BaseSelectOptions from 'components/baseSelectOptions' ;
import { Field } from 'formik';
import CurrencyInput from 'react-currency-input';
import InputMask from "react-input-mask";
import BaseSalarySelect from "components/baseSalarySelect"; 

const ExperienceForm = ({errors, touched, handleChange, values, element, removeExperienceForm, options, setFieldValue}) => {

    const onRemoveForm = () => removeExperienceForm(element.id);
    const [isActual, setIsActual] = useState(false);
    const [exampleOptionsArray, setExampleOptionsArray] = useState([
        {
            id: 'Renuncia',
            nombre: 'Renuncia'
        },
        {
            id: 'Despido',
            nombre: 'Despido'
        },
        {
            id: 'Desahucio',
            nombre: 'Desahucio'
        }
    ]);

    useEffect(() => {
        if (values[`current_${element.id}`]) {
            disabledEndYear();
        }
    }, [])

    const onChangeRadio = (event) => {
        if (event.target.value == "true") {
            values[`current_${element.id}`] = true 
            disabledEndYear();
        } else {
            values[`current_${element.id}`] = false
            setIsActual(false);
        }
    }

    const disabledEndYear = () => {
        values[`endyear_${element.id}`] = '';
        values[`endDate_${element.id}`] = '';
        values[`departureReason_${element.id}`] = '';
        setIsActual(true);
    }

    return (
        <>
            <Form.Group as={Col} md="3" controlId={"validationcompany_" + element.id}>
                <Form.Label>Empresa *</Form.Label>
                <Form.Control
                    type="text"
                    name={`company_${element.id}`}
                    placeholder="Escriba aqui"
                    value={values[`company_${element.id}`]}
                    onChange={handleChange}
                    isInvalid={!!errors[`company_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`company_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="3" controlId={"validationfunctions_" + element.id}>
                <Form.Label>Puesto *</Form.Label>
                <Form.Control
                    type="text"
                    name={`functions_${element.id}`}
                    placeholder="Escriba aqui"
                    value={values[`functions_${element.id}`]}
                    onChange={handleChange}
                    isInvalid={!!errors[`functions_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`functions_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="3" controlId={"validationsupervisor_" + element.id}>
                <Form.Label>Supervisor *</Form.Label>
                <Form.Control
                    type="text"
                    name={`supervisor_${element.id}`}
                    placeholder="Escriba aqui"
                    value={values[`supervisor_${element.id}`]}
                    onChange={handleChange}
                    isInvalid={!!errors[`supervisor_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`supervisor_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="3" controlId={"validationphone_" + element.id}>
                <Form.Label>Teléfono *</Form.Label>
                <Form.Control
                    as={InputMask}
                    mask="(999) 999-9999"
                    type="text"
                    name={`phone_${element.id}`}
                    placeholder="Escriba aqui"
                    value={values[`phone_${element.id}`]}
                    onChange={handleChange}
                    isInvalid={!!errors[`phone_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`phone_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group> 

            <BaseSelect
                md={3}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Mes inicio'}
                name={`startDate_${element.id}`}
                url={'Mes'}
            />

            <Form.Group as={Col} md="3" controlId={"validationstartyear_" + element.id}>
                <Form.Label>Año inicio</Form.Label>
                <Form.Control
                    type="number"
                    name={`startyear_${element.id}`}
                    placeholder="Escriba aqui"
                    value={values[`startyear_${element.id}`]}
                    onChange={handleChange}
                    isInvalid={!!errors[`startyear_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`startyear_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <BaseSelect
                md={3}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Mes fin'}
                disabled={isActual}
                name={`endDate_${element.id}`}
                url={'Mes'}
            />

            <Form.Group as={Col} md="3" controlId={"validationendyear_" + element.id}>
                <Form.Label>Año fin</Form.Label>
                <Form.Control
                    type="number"
                    name={`endyear_${element.id}`}
                    placeholder="Escriba aqui"
                    value={values[`endyear_${element.id}`]}
                    disabled={isActual}
                    onChange={handleChange}
                    isInvalid={!!errors[`endyear_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`endyear_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="3" controlId={"validationsalarioAspirado"}>
                <Form.Label>Último salario mensual devengado *</Form.Label>
                <Form.Control
                    as={CurrencyInput}
                    type="text"
                    name={`monthlySalary_${element.id}`}
                    placeholder="RD$0.00"
                    value={values[`monthlySalary_${element.id}`]}
                    onChange={d => setFieldValue(`monthlySalary_${element.id}`, d)}
                    isInvalid={!!errors[`monthlySalary_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`monthlySalary_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <BaseSelectOptions
                md={3}
                disabled={isActual}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Motivo de salida'}
                name={`departureReason_${element.id}`}
                options={exampleOptionsArray}
            />

            <Form.Group as={Col} md="12" controlId={"validationcurrent_" + element.id}>
                <div>
                    <Form.Label> <b> Actual </b> </Form.Label>
                    
                    <div onChange={onChangeRadio}>
                        <input type="radio" value="true" name={`current_${element.id}`}  defaultChecked={values[`current_${element.id}`]}  /> {' '}Sí
                        &nbsp;&nbsp;<input type="radio" value="false" name={`current_${element.id}`}  defaultChecked={!values[`current_${element.id}`]} />  {' '}No
                    </div>

                    {/* &nbsp;&nbsp; <Field type="checkbox" name={`current_${element.id}`}/>
                    {' '} {values[`current_${element.id}`] ? 'Sí' : 'No' } */}
                </div>
            </Form.Group>

            <Form.Group as={Col} md="12">
                <Button onClick={onRemoveForm} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default ExperienceForm;